import { render, staticRenderFns } from "./ReferralPrescription.vue?vue&type=template&id=48c8286b&scoped=true"
import script from "./ReferralPrescription.vue?vue&type=script&lang=js"
export * from "./ReferralPrescription.vue?vue&type=script&lang=js"
import style0 from "./ReferralPrescription.vue?vue&type=style&index=0&id=48c8286b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c8286b",
  null
  
)

export default component.exports